module.exports = __webpack_public_path__ + "cfd41a194f879f36a2002372845eb54a.svg";